/* Feetee CRO v11 — pointer-events fix for sticky bar; mobile-compatible ATC */
(function(){

if(typeof window.autoFillStockHandler==='undefined'){window.autoFillStockHandler=function(){};}

// ── Inject CSS: hidden sticky bar must NEVER absorb touch events ──────────────
// transform:translateY(100%) hides it visually but NOT from touch on mobile.
// This fixes the main ATC button being un-tappable when sticky bar is off-screen.
(function(){
  var s=document.createElement('style');
  s.textContent='#ft-sticky-atc:not(.ft-sticky-visible){pointer-events:none!important;touch-action:none!important}';
  (document.head||document.documentElement).appendChild(s);
})();

// ── Price sync + dynamic % OFF badge ─────────────────────────────────────────
function syncBigPrice(){
  var card=document.querySelector('.quantity-break-option.selected');
  if(!card)return;
  var priceEl=card.querySelector('.quantity-break-price-container');
  if(!priceEl)priceEl=card.querySelector('[class*="price"]');
  var bigPrice=document.querySelector('.ft-price-now');
  var bigWas=document.querySelector('.ft-price-was');
  var bigBadge=document.querySelector('.ft-price-badge');
  var bigNote=document.querySelector('.ft-price-note');
  var stickyPrice=document.getElementById('ft-sticky-price');

  if(priceEl){
    var rawText=priceEl.textContent.trim();
    var matches=rawText.match(/\$[\d,]+\.?\d*/g)||[];
    var currentPrice=matches[0]||'';
    var wasPrice=matches[1]||'';
    if(currentPrice&&bigPrice)bigPrice.textContent=currentPrice;
    if(currentPrice&&stickyPrice)stickyPrice.textContent=currentPrice;
    if(wasPrice&&bigWas)bigWas.textContent=wasPrice;
    if(currentPrice&&wasPrice&&bigBadge){
      var curr=parseFloat(currentPrice.replace(/[$,]/g,''));
      var was=parseFloat(wasPrice.replace(/[$,]/g,''));
      if(was>0&&curr<was){bigBadge.textContent=Math.round((1-curr/was)*100)+'% OFF';}
    }
  }

  if(bigNote){
    var all=document.querySelectorAll('.quantity-break-option');
    var idx=-1;
    all.forEach(function(c,i){if(c.classList.contains('selected'))idx=i;});
    if(idx===0)bigNote.textContent='Or save more with Buy 2 or Buy 4 below \u2193';
    else if(idx===1)bigNote.textContent='Or save even more with Buy 4 below \u2193';
    else if(idx>=2)bigNote.textContent='Best value pack \u2014 maximum saving';
  }
}

function initPriceSync(){
  var container=document.querySelector('.quantity-break-container,.quantity-break-form,[class*="quantity-break"]');
  if(!container){setTimeout(initPriceSync,400);return;}
  syncBigPrice();
  new MutationObserver(syncBigPrice).observe(container,{subtree:true,attributes:true,attributeFilter:['class']});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initPriceSync);}
else{initPriceSync();}
setTimeout(function(){initPriceSync();syncBigPrice();},1200);

// ── Move savings badge ────────────────────────────────────────────────────────
function moveSavings(){
  document.querySelectorAll('.quantity-break-option').forEach(function(card){
    var s=card.querySelector('.quantity-break-savings');
    var w=card.querySelector('.quantity-break-content-wrapper');
    if(s&&w&&s.parentNode!==w){w.appendChild(s);}
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',moveSavings);}
else{moveSavings();}
setTimeout(moveSavings,800);

// ── Sticky ATC ────────────────────────────────────────────────────────────────
function initStickyATC(){
  var bar=document.getElementById('ft-sticky-atc');
  if(!bar)return;
  var mainBtn=document.querySelector('.shop-add-to-cart-button');
  if(!mainBtn){setTimeout(initStickyATC,400);return;}
  new IntersectionObserver(function(entries){
    bar.classList.toggle('ft-sticky-visible',!entries[0].isIntersecting);
  },{threshold:0}).observe(mainBtn);
  var sBtn=document.getElementById('ft-sticky-btn');
  if(sBtn){
    // On mobile, synthetic .click() from our handler may be ignored by the
    // Quantity Break app if it checks event.isTrusted. Workaround: when the
    // user taps our sticky button (trusted touch), scroll the main button into
    // view and attempt both a native click() and form submit dispatch.
    sBtn.addEventListener('click',function(){
      var btn=document.querySelector('.shop-add-to-cart-button');
      if(!btn)return;
      btn.click();
      // Also try submitting the underlying form in case app uses submit listener
      var form=btn.closest('form');
      if(form){
        try{
          form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
        }catch(e){}
      }
      // Fallback: if nothing happened after 400ms, scroll to the native button
      setTimeout(function(){
        var cartDrawer=document.querySelector('.cart-drawer,.cart-notification,[id*="cart"][class*="open"]');
        if(!cartDrawer){
          btn.scrollIntoView({behavior:'smooth',block:'center'});
        }
      },400);
    });
  }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initStickyATC);}
else{initStickyATC();}

// ── Guarantee badge on gallery image ─────────────────────────────────────────
function injectGuaranteeBadge(){
  if(document.getElementById('ft-guar-badge'))return;
  var img=document.querySelector('.shop-product-gallery img')||document.querySelector('[class*="product-gallery"] img')||document.querySelector('[class*="product-media"] img')||document.querySelector('.shop-product-section img');
  if(!img){setTimeout(injectGuaranteeBadge,700);return;}
  var p=img.parentElement;
  if(window.getComputedStyle(p).position==='static')p.style.position='relative';
  p.insertAdjacentHTML('beforeend','<div id="ft-guar-badge" style="position:absolute;top:12px;left:12px;width:56px;height:56px;border-radius:50%;background:#1C1C1A;color:#FAF8F5;display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:Inter,sans-serif;font-size:9px;font-weight:700;line-height:1.25;text-align:center;z-index:10"><span style="font-size:13px">100</span><span>Day</span><span>Money</span><span>Back</span></div>');
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',injectGuaranteeBadge);}
else{injectGuaranteeBadge();}
setTimeout(injectGuaranteeBadge,1200);

})();
